import {
  setCookie,
  setDotCookie,
  setRawDomainCookie,
  ClearAllCookie
} from "utils/cookieUtils"

import {
	useUrlStore
} from '@/store/UrlStore'
import { clearTenantContextCache } from "@/components/easy";

export function clearLoginState() {
	// 清除cookie
	setDotCookie("X-HC-TOKEN", "", -1000)
	setRawDomainCookie("X-HC-TOKEN", "", -1000)
	setCookie('_xhcsid', "", -1000)
	ClearAllCookie()
	useUrlStore().clear();
	
	clearTenantContextCache();
}

// export function logout() {
//   // setCookie("X-HC-TOKEN", "", -1000)
//   setDotCookie("X-HC-TOKEN", "", -1000)
//   setRawDomainCookie("X-HC-TOKEN", "", -1000)
//   ClearAllCookie()
//   useAccountMessageStore().$reset()
//   try {
//     getJdEid(function (eid, fp, udfp) {
//       const currentCookie = document.cookie
//       window["eid"] = eid
//       document.cookie = "eid=" + eid + ";" + currentCookie
//     })
//   } catch (e) {
//     console.log(e)
//   }
// }
